import apiClient from "./http";

export const getClients = (page = 1, pageSize = 20) =>
  apiClient.get("/Clients", { params: { page, pageSize } });

export const createClient = (payload) => apiClient.post("/Clients", payload);

export const updateClient = (id, payload) =>
  apiClient.put(`/Clients/${id}`, payload);

export const deleteClient = (id) => apiClient.delete(`/Clients/${id}`);

export const getClientById = () => {
  // Blocked — backend API not defined in implementation doc.
  return Promise.reject(
    new Error("Blocked — backend API not defined in implementation doc")
  );
};
